import { useEffect, useState } from 'react';
import AdvancedFilters, {
  AdvancedFiltersProps,
  AdvancedFiltersState,
} from 'src/components/AdvancedFilters';
import { useGetContractFilters } from 'src/pages/ContractsPage/api';

export function ContractFilters({
  open,
  filters,
  handleSearch,
}: AdvancedFiltersProps) {
  const { data } = useGetContractFilters({ enabled: open });

  const [advancedFilters, setAdvancedFilters] = useState<
    AdvancedFiltersState[]
  >([{}]);

  useEffect(() => {
    setAdvancedFilters(filters.length ? filters : [{}]);
  }, [open, filters]);

  return (
    <AdvancedFilters
      open={open}
      data={data}
      filters={advancedFilters}
      handleSearch={handleSearch}
      setFilters={setAdvancedFilters}
    />
  );
}
